import { client } from '@repo/api-kit/queries/utils';

import { apiBaseURL } from 'register-partners-js/constants/hosts';

client.init({
  baseURL: apiBaseURL,
});
